

import Gallery from '../../../../modules/Gallery';


import foto_1 from './foto_1.jpg'
import foto_2 from './foto_2.jpg'
import foto_3 from './foto_3.jpg'
import foto_4 from './foto_4.jpg'


const slides = [
    {
      src: foto_1,
      title: 'Slide Title One',
      description: 'Slide Description One\n\nthis is new line',
    },
    {
      src: foto_2,
      title: 'Slide Title Two',
      description: 'Slide Description Two',
    },
    {
      src: foto_3,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    },
    {
      src: foto_4,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    }
]



export default function Index() {

    return (
        <div className='container'>

            <div className='mt-3'>
                <h3>Capacitación salud ocupacional 2024</h3>
                <p>
                    En el marco de nuestra dimensión estratégica educativa, COOPMULMAG 
                    reafirma su compromiso con la formación continua de su equipo humano. 
                    En esta jornada, avanzamos en temas clave como salud ocupacional, 
                    seguridad en el trabajo, manejo responsable del entorno laboral y 
                    tratamiento adecuado de residuos sólidos, fortaleciendo así una cultura 
                    organizacional consciente, segura y sostenible.</p>
            </div>
            <Gallery slides={slides} ></Gallery>
        </div>
    )

}